import { render, staticRenderFns } from "./SummaryView.vue?vue&type=template&id=4b7043fa&"
import script from "./SummaryView.vue?vue&type=script&lang=ts&"
export * from "./SummaryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports